import React from 'react';

import { Header, SideBar } from 'components';
import { SiedeBarProvider } from 'contexts/SideBarProvider';

import { Container, Main } from './styles';
import Content from './Content';

const PrivateLayout: React.FC = ({ children }) => {
  return (
    <Container>
      <SiedeBarProvider>
        <Header />
        <Main>
          <SideBar />
          <Content>{children}</Content>
        </Main>
      </SiedeBarProvider>
    </Container>
  );
};

export default PrivateLayout;
